export interface ServiceData {
  title: string;
  description: string;
}

export const SERVICES: ServiceData[] = [
  {
    title: 'Development',
    description:
      'Custom web applications, e-commerce platforms, and mobile apps built for performance, security, and future growth.',
  },
  {
    title: 'Design & UX/UI',
    description:
      'Intuitive, conversion-focused interfaces that combine aesthetics with seamless user experience.',
  },
  {
    title: 'Infrastructure & Integrations',
    description:
      'Scalable infrastructure, DevOps solutions, and integrations that keep your systems fast, reliable, and connected.',
  },
  {
    title: 'Support & Maintenance',
    description:
      'Continuous monitoring, updates, and optimization for stable, secure performance and long-term reliability.',
  },
  {
    title: 'Audit & Optimization',
    description:
      'In-depth technical, UX, and SEO audits that identify issues and improve overall website efficiency.',
  },
  {
    title: 'Security & Quality',
    description:
      'Robust security, compliance, and quality standards that protect your data and ensure reliable digital experiences.',
  },
];
